import { render, staticRenderFns } from "./WaterView.vue?vue&type=template&id=5e44321a&scoped=true"
import script from "./WaterView.vue?vue&type=script&lang=js"
export * from "./WaterView.vue?vue&type=script&lang=js"
import style0 from "./WaterView.vue?vue&type=style&index=0&id=5e44321a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44321a",
  null
  
)

export default component.exports